const envString = (value: string | undefined): string | undefined => {
    const trimmed = value?.trim();
    return trimmed || undefined;
};

const reactApp = (name: keyof ImportMetaEnv): string | undefined =>
    envString(import.meta.env[name] as string | undefined);

const isGoogleMapsApiKey = (value: string | undefined): value is string =>
    !!value && value.startsWith('AIza');

const resolveMapApiKey = (): string | undefined => {
    for (const name of [
        'REACT_APP_MAP_API_KEY',
        'REACT_APP_MAP_ACCESS_TOKEN',
        'REACT_APP_GOOGLE_MAP_ID',
    ] as const) {
        const value = reactApp(name);
        if (isGoogleMapsApiKey(value)) return value;
    }
    return undefined;
};

const resolveGoogleMapId = (): string => {
    const value = reactApp('REACT_APP_GOOGLE_MAP_ID');
    if (value && !isGoogleMapsApiKey(value)) return value;
    return 'DEMO_MAP_ID';
};

export const env = {
    baseUrl: reactApp('REACT_APP_BASE_URL'),
    apiBaseUrl: reactApp('REACT_APP_API_BASE_URL'),
    environment: reactApp('REACT_APP_ENVIRONMENT'),
    appEnv: reactApp('REACT_APP_ENV'),
    gitSha: reactApp('REACT_APP_GIT_SHA'),
    mapApiKey: resolveMapApiKey(),
    mapAccessToken: reactApp('REACT_APP_MAP_ACCESS_TOKEN'),
    googleMapId: resolveGoogleMapId(),
    mapDefaultLatitude: reactApp('REACT_APP_MAP_DEFAULT_LATITUDE'),
    mapDefaultLongitude: reactApp('REACT_APP_MAP_DEFAULT_LONGITUDE'),
    loginEntraIdEnabled:
        import.meta.env.REACT_APP_LOGIN_ENTRA_ID_ENABLED === 'true',
    loginEmailPasswordEnabled:
        import.meta.env.REACT_APP_LOGIN_EMAIL_PASSWORD_ENABLED !== 'false',
    entraClientId: reactApp('REACT_APP_ENTRA_CLIENT_ID'),
    tenantId: reactApp('REACT_APP_TENANT_ID'),
    entraScope: reactApp('REACT_APP_ENTRA_SCOPE'),
    awsPlatformOnboardingUrl: reactApp('REACT_APP_AWS_PLATFORM_ONBOARDING_URL'),
    dmrBaseUrl: reactApp('REACT_APP_DMR_BASE_URL'),
    statusPageUrl: reactApp('REACT_APP_STATUS_PAGE_URL'),
    tenant: reactApp('REACT_APP_TENANT'),
    tenantName: reactApp('REACT_APP_TENANT_NAME'),
    versionFileUrl: reactApp('REACT_APP_VERSION_FILE_URL'),
    sentryApiKey: reactApp('REACT_APP_SENTRY_API_KEY'),
    tracesSampleRate: reactApp('REACT_APP_TRACES_SAMPLE_RATE'),
    recaptchaSiteKey: reactApp('REACT_APP_RECAPTCHA_SITE_KEY'),
} as const;
